// TODO: IN-3914: cleanup InvestmentExperienceDocuments, return default from ./ManagedAccountDocuments
import React from 'react';
import fr from 'facet-rest';
import {
  useManagedAccountPageContext,
} from 'Views/Page/Content/Templates/ManagedAccountPageTemplate/Context/ManagedAccountPageContext';
import ManagedAccountDocuments from './ManagedAccountDocuments';
import ManagedAccountDocumentsTabPanelLayout from '../ManagedAccountDocumentsTabPanelLayout';

export default function ManagedAccountDocumentsPicker() {
  const { currentTabResource } = useManagedAccountPageContext();

  if (currentTabResource.relationship(fr.relationships.documents.name)) return <ManagedAccountDocuments baseLink={currentTabResource.relationship(fr.relationships.documents.name).link('related')} />;

  return <ManagedAccountDocumentsTabPanelLayout />;
}
